<template>
  <div :class="$b()">
    <div>
      <HorizontalToggle
        v-model="irisToggleValue"
        :class="$b('iris-toggle')"
        :on-value="true"
        :off-value="false"
      >
        <template #off-icon>
          <VisionIcon
            colour="black"
            size="x-small"
            icon="cloudy"
          />
        </template>

        <template #on-icon>
          <VisionIcon
            colour="black"
            size="x-small"
            icon="day-sunny"
          />
        </template>
      </HorizontalToggle>
    </div>
    <BaseCopy
      tag="p"
      size="body-sm"
      :class="$b('text')"
    >
      Our
      <b :class="$b('text-with-icon')">
        8KO®
        <span :class="$b('text-icon')">
          <VisionIcon
            icon="iris"
            colour="black"
            :class="$b('icon')"
          />
        </span>
        Photochromic
      </b>
      lens adjusts to fast-changing light conditions, for no lapse in vision and
      ultimate focus.
    </BaseCopy>
  </div>
</template>

<script>
export default {
  name: 'IrisSwitcher',
  props: {
    showIrisPreview: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change-iris-preview-state'],
  computed: {
    irisToggleValue: {
      get() {
        return this.showIrisPreview
      },
      set(val) {
        this.$emit('change-iris-preview-state', val)
      }
    }
  }
}
</script>

<style lang="postcss">
.IrisSwitcher {
  @apply flex flex-row items-center gap-xs
    py-xs;
}

.IrisSwitcher__text-with-icon {
  @apply inline-flex items-center;
}

.IrisSwitcher__text-icon {
  margin-left: 4px;
  margin-right: 4px;
  font-size: 0.7em;
}

.IrisSwitcher__icon {
  height: 0.7em;
}

.IrisSwitcher__icon .VisionIcon__svg {
  fill: var(--icon-fill) !important;
}
</style>
